import {SCOPE_FULL_SET, SCOPE_SMALL_SET} from "../config/actions";

export function setSmallScope(data) {
    return {
        type: SCOPE_SMALL_SET,
        data
    }
}

export function setFullScope(data) {
    return {
        type: SCOPE_FULL_SET,
        data
    }
}
